import { create } from 'zustand';
import type { PhaseCode } from '../../../components/menu.config';

/**
 * Sélection de phase utilisée pour piloter les étoiles de la sidebar.
 *
 * - `null` => fallback : la phase courante de l'utilisateur (le Layout dérive cette valeur).
 * - Mise à jour lorsqu'on clique sur une phase dans `PhaseTimeline` (page Parcours).
 *
 * Volontairement non persisté : à chaque rechargement on repart sur la phase active.
 */
interface SelectedPhaseState {
  selectedPhaseCode: PhaseCode | null;
  setSelectedPhaseCode: (code: PhaseCode | null) => void;
}

export const useSelectedPhaseStore = create<SelectedPhaseState>((set) => ({
  selectedPhaseCode: null,
  setSelectedPhaseCode: (code) => set({ selectedPhaseCode: code }),
}));
